<div class="custom-input-container" [class.floating-label-container]="floatingLabel">
  <div *ngIf="showSearchIcon" class="search-icon" (click)="onSearchClick()">
    <span class="mdn-Icon-lupa mdn-Icon--mn" aria-label="lupa"></span>
  </div>
  <label *ngIf="floatingLabel && placeholder" class="floating-label" [class.floating-label-active]="hasValue || isFocused" [attr.for]="id || null">
    {{ placeholder.replace('*', '') }}<span *ngIf="placeholder.includes('*') || placeholder.endsWith('*')" class="required-asterisk">*</span>
  </label>
  <input
    [type]="currentInputType"
    [placeholder]="floatingLabel ? '' : placeholder"
    [(ngModel)]="value"
    (ngModelChange)="onChange(value)"
    (focus)="onInputFocus()"
    (blur)="onInputBlur()"
    [disabled]="disabled"
    class="custom-input"
    [class.has-password-toggle]="type === 'password'"
    [class.has-search-icon]="showSearchIcon"
    [class.has-floating-label]="floatingLabel"
    [class.has-value]="hasValue"
    [class.is-focused]="isFocused"
    [id]="id"
    [attr.name]="name"
    [mask]="mask"
    [attr.maxLength]="maxlength"
    [class.error]="error"
    (keydown)="preventSpace($event)"
    (paste)="onPaste($event)"
    (keydown.enter)="onEnterKey($event)"
  />
  <button *ngIf="showClearButton && value && type !== 'password'" type="button" class="clear-button" (click)="clearInput()" [disabled]="disabled">
    <mat-icon>close</mat-icon>
  </button>
  <button *ngIf="showPasswordToggle && type === 'password'" type="button" class="password-toggle-button" (click)="togglePasswordVisibility()">
    <i
      [ngClass]="(isPasswordVisible ? 'bi bi-eye-slash' : 'bi bi-eye') + ' eye-icon-bootstrap'">
    </i>
  </button>
</div>
